import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=0afc1ee7&scoped=true&"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsModal.vue?vue&type=style&index=0&id=0afc1ee7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc1ee7",
  null
  
)

export default component.exports